import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import { getOnboarding } from "../../../../redux/learner/actions";
import {
  selectOnboardings,
  selectOnboardingsLoaded,
  selectOnboardingsLoading,
} from "../../../../redux/learner/selector";

const mapStateToProps = (state: StateType) => ({
  onboardings: selectOnboardings(state),
  loading: selectOnboardingsLoading(state),
  loaded: selectOnboardingsLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getOnboarding,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
